import type { SignupCodesResponse } from 'contracts/api/v4/signup-codes/signup-codes.service'

import type { NormalisedSignupCodesResponse, SignupCodeStatus } from './signup-codes.module.types'

export const handleSuccess = (response: SignupCodesResponse): NormalisedSignupCodesResponse => ({
  codes: response.items.map((serverCode) => ({
    code: serverCode.code,
    organisation: {
      id: serverCode.organisation.id,
      name: serverCode.organisation.name,
      logo: serverCode.organisation.logo,
    },
    startDate: new Date(serverCode.created_on),
    status: serverCode.status as SignupCodeStatus,
    timesUsed: serverCode.times_used,
  })),
})
